import { render, staticRenderFns } from "./pt-route-edit.vue?vue&type=template&id=66bc009b&"
import script from "./pt-route-edit.vue?vue&type=script&lang=js&"
export * from "./pt-route-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports